





























































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {ncpPopup} from '@/utils/ncp';
import {ProductsConfigurableOption, OptionImage} from 'supporter';
import {getCurrency} from '@/utils/commonUtils';
import {popupResize} from '@/utils/ncp';
@Component({
  components: {}
})
export default class ProductSetOptionAddForm extends Vue {
  @Prop({required: true}) private deliveryTemplateNo!: number;
  @Prop({required: true}) private mallNo!: number;
  @Prop({required: true}) private callback!: any;
  @Prop({required: true}) private saleSettingStatusType!: string;
  @Prop() private mallProductNo!: number;
  private templates = '';
  private batchUseYn = 'Y';
  private batchReservationStock:number|string = ''
  @Prop({required: true}) private savedOptions!: any[];
  private options: any[] = [];
  private getCurrency = getCurrency;
  apply() {
    if (!this.templates) {
      alert(window.$t('PRODUCT_OPTION_PLEASE_SET_OPTION_CORRECT'));
      return;
    }
    if (this.options.length) {
      if (!confirm(window.$t('PRODUCT_OPTION_SURE_REGISTER_DELETE'))) {
        return;
      }
    }

    this.options = [];
    const tempArr = this.templates.split(',');
    tempArr.forEach((temp) => {
      this.options.push({
        checked: false,
        index: this.options.length + 1,
        optionImages: [],
        mallOptionNo: 0,
        mapping: {
          productName: '',
          combinedOptionNameValue: '',
          optionManagementCd: '',
          extraManagementCd: '',
          mallOptionNo: '',
          salePrice: '',
          optionSalePrice: '',
          mappingCount: '',
          saleStatusType: '',
          mallProductNo: ''
        },
        purchasePrice: '',
        optionValue: temp,
        useYn: 'Y',
        addPrice: '',
        stockCnt: '',
        mappingFirst: true,
        reservationStockCnt: ''
      });
    });
  }
  get priceIsLegal() {
    return false;
  }
  close() {
    window.close();
  }
  callbackSetProductInfo(products: ProductsConfigurableOption[], index: number) {
    (window as any).callbackSetProductInfo = null;
    if (products.length) {
      const options: any = [];
      let temp: any = null;
      let addPrice = 0;
      let stockCnt = 0;
      products.forEach((product, index) => {
        addPrice += product.optionSalePrice;
        if (index) {
          if (stockCnt > product.stockCnt) {
            stockCnt = product.stockCnt;
          }
        } else {
          stockCnt = product.stockCnt;
        }
      });
      let added = false
      this.options.forEach((item) => {
        if (item.index === index) {
          if(!added){
            products.forEach((product: any, j: number) => {
              temp = $.extend(true, {}, item);
              temp.mappingFirst = !j;
              temp.mapping = {
                productName: product.productName,
                combinedOptionNameValue: product.combinedOptionNameValue,
                optionManagementCd: product.optionManagementCd,
                extraManagementCd: product.extraManagementCd,
                mallOptionNo: product.mallOptionNo,
                salePrice: product.optionSalePrice,
                optionSalePrice: product.optionSalePrice,
                mappingCount: 1,
                saleStatusType: product.saleStatusType,
                saleSettingStatusType: product.saleSettingStatusType,
                mallProductNo: product.mallProductNo,
                stockCnt: product.stockCnt
              };
              temp.addPrice = addPrice;
              temp.stockCnt = stockCnt;
              options.push(temp);
            });
            added = true;
          }
        } else {
          options.push(item);
        }
      });
      this.options = options;
    }
  }
  addSetProduct(index: number) {
    (window as any).callbackSetProductInfo = this.callbackSetProductInfo;
    const filterOptions = this.options.filter((option) => option.index === index && option.mapping.mallProductNo);
    if (filterOptions.length) {
      const selectedProductNoList = filterOptions.map((option) => {
        return {mallProductNo: option.mapping.mallProductNo, mallOptionNo: option.mapping.mallOptionNo};
      });
      ncpPopup(
        `/setProduct/addOptionForm?dataCallback=callbackSetProductInfo&index=${JSON.stringify(index)}&deliveryTemplateNo=${JSON.stringify(this.deliveryTemplateNo)}&mallNo=${JSON.stringify(
          this.mallNo
        )}&data=${JSON.stringify(selectedProductNoList)}`,
        window.$t('PRODUCT_OPTION_CALL_OPTION'),
        1150,
        650
      );
    } else {
      ncpPopup(
        `/setProduct/addOptionForm?dataCallback=callbackSetProductInfo&index=${JSON.stringify(index)}&deliveryTemplateNo=${JSON.stringify(this.deliveryTemplateNo)}&mallNo=${JSON.stringify(
          this.mallNo
        )}`,
        window.$t('PRODUCT_OPTION_CALL_OPTION'),
        1150,
        650
      );
    }
  }
  getRowSpan(option: any) {
    const arr = this.options.filter((item) => item.index === option.index);
    return arr.length;
  }
  getSaleStatusLabel(saleStatusType: string, saleSettingStatusType: string): string {
    if (saleSettingStatusType === 'PROHIBITION_SALE') {
      return '-';
    }
    if (saleStatusType === 'PRE_APPROVAL_STATUS') {
      return window.$t('PRODUCT_OPTION_BEFORE_ADMIT');
    } else if (saleStatusType === 'ON_PRE_SALE') {
      return window.$t('PRODUCT_OPTION_PRE_SELLING');
    } else if (saleStatusType === 'WAITING_SALE') {
      return window.$t('PRODUCT_OPTION_SALE_WAIT');
    } else if (saleStatusType === 'ON_SALE') {
      return window.$t('PRODUCT_OPTION_SELLING');
    } else if (saleStatusType === 'END_SALE') {
      return window.$t('PRODUCT_OPTION_SELL_STOP');
    }
    return saleStatusType;
  }
  getSaleSettingStatusLabel(saleStatusType: string, saleSettingStatusType: string): string {
    if (saleStatusType === 'END_SALE') {
      return '-';
    }

    if (saleSettingStatusType === 'AVAILABLE_FOR_SALE') {
      return window.$t('PRODUCT_OPTION_AVAILABLE_FOR_SALE');
    } else if (saleSettingStatusType === 'WAITING_PRE_SALE') {
      return window.$t('PRODUCT_OPTION_WAITING_PRE_SALE');
    } else if (saleSettingStatusType === 'PROHIBITION_SALE') {
      return window.$t('PRODUCT_OPTION_PROHIBITION_SALE');
    }
    return saleSettingStatusType;
  }
  batchUpdate() {
    const checked = this.options.filter((option) => option.checked);
    if (checked.length) {
      this.options = this.options.map((option) => {
        if (option.checked) {
          option.useYn = this.batchUseYn;
        }
        if(this.useReservationStock){
          option.reservationStockCnt = this.batchReservationStock;
        }
        return option;
      });
    } else {
      alert(window.$t('PRODUCT_OPTION_PLEASE_SELECT_OPTION'));
    }
  }
  changeCheck(index: number) {
    this.options[index].checked = !this.options[index].checked;
  }
  batchImageUpdate() {
    const length = this.options.length ? this.options[this.options.length - 1].index : 0;
    (window as any).callbackOptionImageBatchInfo = this.callbackOptionImageBatchInfo;
    ncpPopup(`/option/image/batch/addForm?mallNo=${this.mallNo}&length=${length}&dataCallback=callbackOptionImageBatchInfo`, 'optionImageForm', 1024, 358);
  }
  callbackOptionImageBatchInfo(imageInfo: any) {
    (window as any).callbackOptionImageBatchInfo = null;
    this.options = this.options.map((option) => {
      imageInfo.forEach((image: any) => {
        option.optionImages.push({mainYn: image.mainYn, mallOptionImageUrl: image.url});
      });
      return option;
    });
  }
  allCheck(e: Event) {
    const target = e.target as HTMLInputElement;
    this.options = this.options.map((option) => {
      option.checked = target.checked;
      return option;
    });
  }
  deleteRow() {
    let optionValue = 0;
    const checkedOptions = this.options.filter((option) => option.checked);
    if (checkedOptions.length) {
      this.options = this.options.filter((option) => {
        if (option.checked) {
          optionValue = option.optionValue;
        }
        return !option.checked && optionValue !== option.optionValue;
      });
    } else {
      alert(window.$t('PRODUCT_OPTION_PLEASE_SELECT_DELETE'));
    }
  }
  toggleTableWrap(e: Event) {
    const hasLarge = $('#optionListTable').hasClass('large');
    $('#optionListTable').toggleClass('large', !hasLarge);
    $(e.target as HTMLButtonElement).html(!hasLarge ? window.$t('PRODUCT_OPTION_SEE_ONE_EYE') : window.$t('PRODUCT_OPTION_SEE_WIDE'));
  }
  addOption() {
    this.options.push({
      checked: false,
      index: this.options.length ? this.options[this.options.length - 1].index + 1 : 1,
      optionImages: [],
      mallOptionNo: 0,
      mapping: {
        productName: '',
        combinedOptionNameValue: '',
        optionManagementCd: '',
        extraManagementCd: '',
        mallOptionNo: '',
        salePrice: '',
        optionSalePrice: '',
        mappingCount: '',
        saleStatusType: '',
        mallProductNo: ''
      },
      optionValue: '',
      useYn: 'Y',
      addPrice: '',
      stockCnt: '',
      mappingFirst: true,
      reservationStockCnt: ''
    });
  }
  addOptionImage(index: number) {
    (window as any).callbackOptionImageInfo = this.callbackOptionImageInfo;
    const images = this.options[index].optionImages;
    ncpPopup(`/option/image/addForm?index=${index}&mallNo=${this.mallNo}&dataCallback=callbackOptionImageInfo&data=${JSON.stringify(images)}`, 'optionImageForm', 1024, 358);
  }
  callbackOptionImageInfo(imageInfo: any) {
    (window as any).callbackOptionInfo = null;
    this.options[imageInfo.index].optionImages = [];
    if (imageInfo.mainImage.url) {
      (this.options[imageInfo.index].optionImages as OptionImage[]).push({mainYn: 'Y', mallOptionImageUrl: imageInfo.mainImage.url});
    }
    const subImages = imageInfo.images.filter((img: any) => img.url);
    subImages.forEach((image: any) => {
      (this.options[imageInfo.index].optionImages as OptionImage[]).push({mainYn: 'N', mallOptionImageUrl: image.url});
    });
  }
  save() {
    if (!this.options.length) {
      alert(window.$t('PRODUCT_OPTION_PLEASE_OPTION'));
      return;
    }
    const hasNotSet = this.options.filter((option) => !option.mapping.mallProductNo);
    if (hasNotSet.length) {
      alert(window.$t('PRODUCT_OPTION_PLEASE_MORE_1'));
      return;
    }

    const hasUseYn = this.options.filter((option) => option.useYn === 'Y');
    if (!hasUseYn.length) {
      alert(window.$t('PRODUCT_OPTION_TIP_USEYN_Y'));
      return;
    }
    let optionErrorReason = '';
    this.options.forEach((option) => {
      if (option.addPrice < 10) {
        optionErrorReason = 'MORE';
      }
      if (option.addPrice >= 1000000000) {
        optionErrorReason = 'UNDER';
      }
    });
    if (optionErrorReason === 'MORE') {
      alert(window.$t('PRODUCT_OPTION_PLEASE_MORE_10'));
      return;
    } else if (optionErrorReason === 'MORE') {
      alert(window.$t('PRODUCT_OPTION_PLEASE_UNDER_10_BILLION'));
      return;
    }
    let options = this.createSaveOptions();
    const discountPrice = Number(this.$route.query.discountPrice);//즉시할인
    const isErrorDiscountSetOption = discountPrice > 0 && options.some(option => option.addPrice < discountPrice);
    if (isErrorDiscountSetOption) {
      alert(window.$t('PRODUCT_OPTION_ERROR_DISCOUNT_PRICE_SET_OPTION'));
      return;
    }

    if (this.mallProductNo) {
      let salePrice = options[0].addPrice
      options.forEach((option)=>{
        if(salePrice > option.addPrice){
          salePrice = option.addPrice
        }
      })
      options = options.map(option=>{
        option.addPrice = option.addPrice - salePrice
        return option
      })
      const params = {mallProductNos: '' + this.mallProductNo};
      const data: any = {
        optionType: 'MAPPING',
        options,
        salePrice
      };
      this.$api.patchProducts({params, data}).then(() => {
        alert(window.$t('PRODUCT_OPTION_TIP_SAVED'));
        window.opener.postMessage({modifyOption: true});
        window.close();
      });
    } else {
      const str = `javascript:window.${this.callback}(${JSON.stringify(options)});`;
      $(window.opener.location).attr('href', str);
      window.close();
    }
  }
  createOptions() {
    const templateArr: any[] = [];
    this.savedOptions.forEach((option) => {
      templateArr.push(option.optionName);
    });
    this.templates = templateArr.toString();
    this.savedOptions.forEach((option, outIndex) => {
      option.mappings.forEach((mapping: any, index: number) => {
        this.options.push({
          checked: false,
          index: outIndex + 1,
          optionImages: option.optionImages,
          mallOptionNo: option.mallOptionNo,
          mapping: {
            productName: mapping.itemProductName ? mapping.itemProductName : mapping.productName,
            combinedOptionNameValue: mapping.combinedOptionNameValue ? mapping.combinedOptionNameValue : mapping.itemCombinedOptionNameValue,
            optionManagementCd: mapping.optionManagementCd ? mapping.optionManagementCd : mapping.itemOptionManagementCode,
            extraManagementCd: mapping.extraManagementCd ? mapping.extraManagementCd : mapping.itemExtraManagementCode,
            mallOptionNo: mapping.itemOptionNo ? mapping.itemOptionNo : mapping.mallOptionNo,
            salePrice: mapping.mappingOptionSalePrice ? mapping.mappingOptionSalePrice : mapping.salePrice,
            optionSalePrice: mapping.optionSalePrice ? mapping.optionSalePrice : mapping.itemOriginalMappingOptionSalePrice,
            mappingCount: mapping.mappingCnt ? mapping.mappingCnt : mapping.mappingCount,
            saleStatusType: mapping.saleStatusType ? mapping.saleStatusType : mapping.itemProductSaleStatusType,
            mallProductNo: mapping.itemProductNo ? mapping.itemProductNo : mapping.mallProductNo,
            stockCnt: mapping.stockCnt ? mapping.stockCnt : mapping.itemStockCount,
            saleSettingStatusType: mapping.saleSettingStatusType ? mapping.saleSettingStatusType : mapping.itemProductSaleSettingStatusType,
          },
          optionValue: option.optionValue,
          useYn: option.useYn,
          addPrice: option.addPrice,
          stockCnt: option.stockInfo ? option.stockInfo.stockCnt : option.stockCnt,
          mappingFirst: !index,
          purchasePrice: option.purchasePrice,
          reservationStockCnt: option.reservationStockCnt
        });
      });
    });
  }
  createSaveOptions() {
    const options: any[] = [];
    let mappings: any[] = [];
    this.options.forEach((option) => {
      if (option.optionValue) {
        mappings = [];
        if (!this.hasOption(option.optionValue, options)) {
          this.options
            .filter((filterOption) => {
              return filterOption.optionValue === option.optionValue;
            })
            .forEach((option) => {
              mappings.push(option.mapping);
            });

          option.mappings = mappings.map(m => ({...m, salePrice: m.salePrice || 0}));
          options.push({
            optionImages: option.optionImages,
            mallOptionNo: option.mallOptionNo,
            mappings: option.mappings,
            optionValue: option.optionValue,
            useYn: option.useYn,
            addPrice: option.addPrice,
            stockCnt: option.stockCnt,
            optionName: option.optionValue,
            stockNo: option.stockNo,
            purchasePrice: option.purchasePrice,
            reservationStockCnt: option.reservationStockCnt
          });
        }
      }
    });
    return options;
  }
  hasOption(optionValue: any, options: any[]) {
    const finded = options.find((option) => option.optionValue === optionValue);
    return !!finded;
  }
  computeAddPrice(index: number) {
    const options = this.options.filter((option) => option.index === index && option.mapping.mappingCount && option.mapping.salePrice);
    let addPrice = 0;
    let stockCnt;
    options.forEach((option, index) => {
      addPrice += option.mapping.mappingCount * option.mapping.salePrice;
      let count = Math.round(option.mapping.stockCnt / option.mapping.mappingCount);
      if (index) {
        stockCnt = stockCnt > count ? count : stockCnt;
      } else {
        stockCnt = count;
      }
    });
    this.options = this.options.map((option) => {
      if (option.index === index) {
        option.addPrice = addPrice;
        option.stockCnt = stockCnt;
      }
      return option;
    });
  }
  onlyNumber(e: Event, index?: number) {
    const target = (e.target as HTMLInputElement)
    let value = target.value;
    const name = target.name;
    if (value.match(/[^0-9]+/g)) {
      value = value.replace(/[^0-9]+/g, '');
    }
    if(name === 'mappingCnt'){
      this.options[index].mapping.mappingCount = value ? Number(value) : value;
    }else if(name === 'reservationStockCnt'){
      this.options[index].reservationStockCnt = value ? Number(value) : value;
    }else if(name === 'batchReservationStock'){
      this.batchReservationStock = value ? Number(value) : value;
    }

    this.$forceUpdate();
  }
  setCommaAmt(e: Event, index: number) {
    const target = e.target as HTMLInputElement
    let value = target.value;
    const name = target.name;
    const arr = value.split(',');
    value = arr.join('');
    if (value.match(/[^0-9]+/g)) {
      value = value.replace(/[^0-9]+/g, '');
    }
    if(name === 'mappingOptionSalePrice'){
      this.inputError['mappingOptionSalePrice' + index] = false;
      this.options[index].mapping.salePrice = value ? Number(value) : value;
    }else if(name === 'purchasePrice'){
      this.options[index].purchasePrice = value ? Number(value) : value;
    }

    this.$forceUpdate();
  }
  private inputError = {};
  private rangeError = {};
  checkSalePrice(index: number) {
    const salePrice = this.options[index].mapping.salePrice;
    if (Number(salePrice) % 10) {
      this.inputError['mappingOptionSalePrice' + index] = true;
    }
    if (Number(salePrice) > 999999999) {
      this.rangeError['mappingOptionSalePrice' + index] = true;
    }
    this.$forceUpdate();
  }
  @Watch('savedOptions')
  onSavedOptionsChanged() {
    this.createOptions();
  }
  private useReservationStock = false;
  created (){
     // 예약재고 사용여부
    if (this.$route.query.useReservationStock) {
      this.useReservationStock = this.$route.query.useReservationStock ==='true';
    }
  }
  mounted() {
    if (this.saleSettingStatusType === 'PROHIBITION_SALE' || this.$route.query.readonly === 'true') {
      this.disableAll();
    }
    this.createOptions();
    this.$nextTick(() => {
      popupResize(1180, 660);
    });
  }
  disableAll() {
    $('button').prop('disabled', true);
    $('input').prop('disabled', true);
    $('select').prop('disabled', true);
  }
  settingOptionValue(e: Event, option: any, index: number){
    const value = (e.target as HTMLInputElement).value;
    const rowSpan = this.getRowSpan(option);
    for(let i = rowSpan; i > 0; i--){
      this.options[index+i-1].optionValue = value;
    }
  }
}
